import Navbar from './components/Navbar';
import Hero from './components/Hero';
import HotRank from './components/HotRank';
import Breaking from './components/Breaking';
import SpeedRank from './components/SpeedRank';
import Topics from './components/Topics';
import Picks from './components/Picks';
import Reviews from './components/Reviews';
import About from './components/About';
import Faq from './components/Faq';
import Newsletter from './components/Newsletter';
import Footer from './components/Footer';
import BackToTop from './components/BackToTop';

export default function Home() {
  return (
    <>
      <Navbar />
      <main>
        <Hero />
        <HotRank />
        <Breaking />
        <SpeedRank />
        <Topics />
        <Picks />
        <Reviews />
        <About />
        <Faq />
        <Newsletter />
      </main>
      <Footer />
      <BackToTop />
    </>
  );
}